export default "__VITE_ASSET__DzrkVii0__"